import React, { useRef, useState } from "react";

import Cross from "./Cross";
import Bullet from "./Bullet";
import { render } from "storyblok-rich-text-react-renderer";
import { gsap } from "gsap";
import FluidImage from "../../../components/fluidImage";
import { max, min } from "lodash-es";
import Link from "../../../utils/link";

const remToPx = (rem) => {
  const baseFontSize = window
    .getComputedStyle(document.body)
    .getPropertyValue("font-size")
    .replace("px", "");
  return 0.0145 * window.innerWidth * rem;
};

const clampX = (x, min, max) => {
  return Math.min(Math.max(x, min), max);
};

const ServiceDropdown = (props) => {
  const imageRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const onPointerMove = (e) => {
    // move the imageRef (the wrapper) using gsap to where the mouse is.
    // adjust based on -10rem

    if (imageRef.current == null) {
      return;
    }

    const imageRect = imageRef.current.getBoundingClientRect();

    // page margin is min(2.6vw, 50px)

    // set min x to be page margin

    const minX = 0;

    const maxX = remToPx(28.625) - remToPx(20);

    const x = clampX(
      e.clientX - window.innerWidth * 0.75 + remToPx(14),
      0,
      remToPx(28.625) - remToPx(25)
    );
    // set y to be relative to the parent div (the wrapper) so there's no weird offset
    const y =
      e.clientY -
      imageRef.current.parentElement.getBoundingClientRect().top -
      imageRect.height / 2;
    gsap.to(imageRef.current, {
      x: x,
      y: y,
      duration: 0.5,
      ease: "power2.out",
    });
  };

  const [isOpen, setIsOpen] = useState(props.initialOpen);

  const dropdownRef = useRef(null);

  const getMaxHeight = () => {
    if (dropdownRef.current) {
      return isOpen ? `${dropdownRef.current.scrollHeight}px` : `0px`;
    } else {
      if (props.initialOpen == true) {
        return `100%`;
      }
    }
  };

  return (
    <li
      className="space-y-4 relative"
      onPointerMove={onPointerMove}
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}
    >
      {props.subService.hover_image != undefined && (
        <div
          className="absolute w-[28vw] h-[20vw] -left-[calc(100%-16vw)] pointer-events-none z-[-1] mobile:hidden"
          ref={imageRef}
        >
          <FluidImage
            image={props.subService.hover_image}
            className={`transition-opacity duration-500 ${
              isActive ? `opacity-100` : `opacity-0`
            }`}
          />
        </div>
      )}

      <div
        className="flex flex-row justify-between"
        onClick={() => setIsOpen(!isOpen)}
      >
        {props.subService.linked_page?.cached_url != undefined ? (
          <Link className="lg:text-3xl font-medium w-fit" to={props.subService.linked_page.cached_url}>
            {props.subService.service}
          </Link>
        ) : (
          <h3 className="lg:text-3xl font-medium w-fit">
            {props.subService.service}
          </h3>
        )}
        <Cross isOpen={isOpen} className="lg:hidden" />
      </div>

      <div
        className="lg:pr-12 space-x-2 lg:space-x-12 items-center justify-center hidden lg:flex"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <div>{render(props.subService.copy)}</div>
        </div>
        <div className="hidden">
          <Cross isOpen={isOpen} />
        </div>
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? `opacity-100` : `max-h-0 opacity-0`
        }`}
        ref={dropdownRef}
        style={{
          maxHeight: getMaxHeight(),
        }}
      >
        <ol className="grid grid-cols-2 gap-2 lg:gap-0 lg:flex lg:space-x-10 font-semibold flex-wrap">
          <li className="col-span-2 lg:hidden">
            <div className="font-normal">{render(props.subService.copy)}</div>
          </li>
          {/*
                        props.subService.sub_services.map((subService, index) => {
                            return (
                                <li key={`sub-service-item-${index}`} className={`${index == 0 ? `lg:!ml-0` : ``}`}>
                                    <div className="text-sm lg:text-lg uppercase flex items-center lg:justify-center space-x-2">
                                        <span aria-hidden="true">
                                            <Bullet />
                                        </span>
                                        <p>{subService.sub_service}</p>
                                    </div>
                                </li>
                            )
                        })
                    */}
        </ol>
      </div>
    </li>
  );
};

export default ServiceDropdown;
